export const GET_VCARD_START = "GET_VCARD_START";
export const SET_VCARD = "SET_VCARD";
export const GET_VCARD_END = "GET_VCARD_END";

export const CLEAR_VCARD = "CLEAR_VCARD";
